import { render, staticRenderFns } from "./productdetails.vue?vue&type=template&id=4e48d6d0&scoped=true&"
import script from "./productdetails.vue?vue&type=script&lang=js&"
export * from "./productdetails.vue?vue&type=script&lang=js&"
import style0 from "./productdetails.vue?vue&type=style&index=0&id=4e48d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48d6d0",
  null
  
)

export default component.exports